import { render, staticRenderFns } from "./pfxmForm.vue?vue&type=template&id=4bfaed17&scoped=true"
import script from "./pfxmForm.vue?vue&type=script&lang=js"
export * from "./pfxmForm.vue?vue&type=script&lang=js"
import style0 from "./pfxmForm.vue?vue&type=style&index=0&id=4bfaed17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfaed17",
  null
  
)

export default component.exports